import { render, staticRenderFns } from "./VSlidesServices.vue?vue&type=template&id=a29d73b0"
import script from "./VSlidesServices.vue?vue&type=script&lang=js"
export * from "./VSlidesServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports